


























import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({
    name: "Accordion",
    props: {
        isOpen: {
            type: Boolean,
            required: false,
            default: false,
        }
    },
    data: function() {
        return {
            internalIsOpen: this.isOpen,
            uniqueId: uuidv4(),
        };
    },
    methods: {
        toggle: function() {
            this.internalIsOpen = !this.internalIsOpen;
            this.$emit("update-value", this.internalIsOpen);
            if (this.internalIsOpen === false) {
                this.$emit("close");
            }
        }
    }
});

